import { Action } from 'redux'

export interface PatrimonyState {
  isEditing: boolean
  patrimony: any[]
  loadingPatrimony: boolean
  savingPatrimony: boolean
  selectedIndex: number | null
  removingPatrimony: boolean
  filterPatrimony: string
  filters: {
    dateFrom: string
    dateTo: string
  }
}

export enum PatrimonyActionTypes {
  GET_PATRIMONY_SUCCESS = '@@patrimony/GET_PATRIMONY_SUCCESS',
  GET_PATRIMONY_START = '@@patrimony/GET_PATRIMONY_START',
  GET_PATRIMONY_ERROR = '@@patrimony/GET_PATRIMONY_ERROR',

  EDITING_START = '@@patrimony/EDITING_START',
  EDITING_CANCEL = '@@patrimony/EDITING_CANCEL',

  SAVE_PATRIMONY_START = '@@patrimony/SAVE_PATRIMONY_START',
  SAVE_PATRIMONY_SUCCESS = '@@patrimony/SAVE_PATRIMONY_SUCCESS',
  SAVE_PATRIMONY_ERROR = '@@patrimony/SAVE_PATRIMONY_ERROR',

  REMOVE_PATRIMONY_START = '@@patrimony/REMOVE_PATRIMONY_START',
  REMOVE_PATRIMONY_SUCCESS = '@@patrimony/REMOVE_PATRIMONY_SUCCESS',
  REMOVE_PATRIMONY_ERROR = '@@patrimony/REMOVE_PATRIMONY_ERROR',

  CLEAR_PATRIMONY = '@@patrimony/CLEAR_PATRIMONY',

  FILTER_PATRIMONY = '@@patrimony/FILTER_PATRIMONY',
  SET_FILTERS = '@@patrimony/SET_FILTERS',
}

export interface PatrimonyAction extends Action<PatrimonyActionTypes> {
  index?: number
  patrimony?: PatrimonyState['patrimony']
  filters?: PatrimonyState['filters']
  filterPatrimony?: string
}
